const getRutNotFormatted = (value = '') => {
  const cleaned = value.replaceAll('.', '').replaceAll('-', '');

  return `${cleaned}`;
};

export default getRutNotFormatted;
